import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { DatePicker, Space } from "antd";
import {
  Col,
  Container,
  Row,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardText,
  Button,
  Spinner,
} from "reactstrap";
import Footer from "./partials/Footer";
import Header from "./partials/Header";
import {
  addGameToCard,
  fetchGames,
  removeGameFromCard,
} from "../redux/actions/gameActions";
import moment from "moment";
import { Link } from "react-router-dom";
import "antd/dist/antd.css";
export class Games extends Component {
  state = { searchText: "", active: -1, date: "" };
  componentDidMount() {
    this.props.fetchGames();
  }
  isItemInCart = (id) => {
    let cart = JSON.parse(localStorage.getItem("cart"));
    if (cart != null) {
      let exist = cart.find((item) => item == id);
      if (exist) return true;
    }
    return false;
  };
  searchedGames = (game) => {
    return (
      game.games &&
      game.games.filter(
        (game) =>
          game.title
            .toLowerCase()
            .includes(this.state.searchText.toLowerCase()) ||
          game.address
            .toLowerCase()
            .includes(this.state.searchText.toLowerCase())
      )
    );
  };
  render() {
    let { game } = this.props;
    return (
      <Fragment>
        <Header
          {...this.props}
          path={["Home", "Games"]}
          login={false}
          heading="Games"
        />
        <Container className="text-white-1 margin-top-fix">
          <Row className="align-items-center justify-content-end">
            <Col xl={3} className="mt-3 mt-xl-0">
              <Row className="align-items-center">
                <Col xl={12} md={6} className="mt-3 mt-md-0">
                  <div className="position-relative searchbar-wrapper">
                    <DatePicker
                      type="date"
                      className="form-control bg-dark-1 "
                      placeholder="Search"
                      style={{ padding: "15px", color: "white" }}
                      format="YYYY-MM-DD"
                      onChange={(value) => {
                        if (value) {
                          this.setState({ date: value });
                        } else {
                          this.setState({ date: "" });
                        }
                      }}
                      // min={moment().format("YYYY-MM-DD")}//for minimum today value
                    />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xl={3} className="mt-3 mt-xl-0">
              <Row className="align-items-center">
                <Col xl={12} md={6} className="mt-3 mt-md-0">
                  <div className="position-relative searchbar-wrapper">
                    <input
                      type="text"
                      className="form-control bg-dark-1"
                      placeholder="Search"
                      onChange={(e) => {
                        this.setState({ searchText: e.target.value });
                      }}
                    />
                    <span
                      className="position-absolute"
                      style={{
                        top: "50%",
                        right: "25px",
                        transform: "translateY(-50%)",
                      }}
                    >
                      <i className="fa fa-search" />
                    </span>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="mb-5 mt-3">
            {game.games == -1 ? (
              <div className="d-flex align-items-center justify-content-center my-5">
                <Spinner />
              </div>
            ) : game.games && game.games.length == 0 ? (
              <div className="d-flex align-items-center justify-content-center my-5">
                No Game Found
              </div>
            ) : this.state.searchText == "" ? (
              game.games &&
              game.games.filter((game) => {
                if (this.state.date) {
                  return moment(game.start_date.toDate()).isSame(
                    moment(this.state.date)
                  );
                } else {
                  return true;
                }
              }).length ? (
                game.games
                  .filter((game) => {
                    if (this.state.date) {
                      return moment(game.start_date.toDate()).isSame(
                        moment(this.state.date)
                      );
                    } else {
                      return true;
                    }
                  })
                  .map((game) => (
                    <Col
                      key={`GameCard${game.id}`}
                      xl={3}
                      lg={6}
                      md={6}
                      sm={6}
                      className="mt-4"
                    >
                      <Link
                        className="text-decoration-none"
                        to={"/event-purchase/" + game.id}
                        // to={{ pathname: "/event-purchase", state: game.id }}
                      >
                        <Card className="bg-dark-1 text-white-1 game-card">
                          <div
                            className="game-img game-img-1"
                            style={{ backgroundImage: `url(${game.img})` }}
                          ></div>
                          <CardBody>
                            <CardTitle tag="h6">{game.title}</CardTitle>
                            <CardSubtitle
                              tag="h6"
                              className="mb-2 text-muted mt-3"
                            >
                              {game.address}
                            </CardSubtitle>
                            <CardSubtitle
                              tag="h6"
                              className="mb-2 text-muted mt-3"
                            >
                              {moment(game.start_date.toDate()).format(
                                "DD MMM YYYY"
                              )}
                            </CardSubtitle>
                            <div className="d-flex mt-3">
                              <p className="mt-1">Price:</p>
                              <p className="px-2 mt-1 text-green-1">
                                ${game.price}
                              </p>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.isItemInCart(game.id)
                                    ? this.props.removeGameFromCart(game.id)
                                    : this.props.addGameToCart(game.id);
                                }}
                                className="ms-auto text-white-1 px-4 bg-dark-4 btn-join"
                              >
                                {this.isItemInCart(game.id)
                                  ? "Remove"
                                  : "Join Now"}
                              </button>
                            </div>
                          </CardBody>
                        </Card>
                      </Link>
                    </Col>
                  ))
              ) : (
                <div className="d-flex align-items-center justify-content-center my-5">
                  No Game Found
                </div>
              )
            ) : this.searchedGames(game).length == 0 ? (
              <div className="d-flex align-items-center justify-content-center my-5">
                No Game Found
              </div>
            ) : this.searchedGames(game).filter((game) => {
                if (this.state.date) {
                  return moment(game.start_date.toDate()).isSame(
                    moment(this.state.date)
                  );
                } else {
                  return true;
                }
              }).length ? (
              this.searchedGames(game)
                .filter((game) => {
                  if (this.state.date) {
                    return moment(game.start_date.toDate()).isSame(
                      moment(this.state.date)
                    );
                  } else {
                    return true;
                  }
                })
                .map((game) => (
                  <Col
                    key={`GameCard${game.id}`}
                    xl={3}
                    lg={6}
                    md={6}
                    sm={6}
                    className="mt-4"
                  >
                    <Link
                      className="text-decoration-none"
                      to={"/event-purchase/" + game.id}
                      // to={{ pathname: "/event-purchase", state: game.id }}
                    >
                      <Card className="bg-dark-1 text-white-1 game-card">
                        <div
                          className="game-img game-img-1"
                          style={{ backgroundImage: `url(${game.img})` }}
                        ></div>
                        <CardBody>
                          <CardTitle tag="h6">{game.title}</CardTitle>
                          <CardSubtitle
                            tag="h6"
                            className="mb-2 text-muted mt-3"
                          >
                            {game.address}
                          </CardSubtitle>
                          <CardSubtitle
                            tag="h6"
                            className="mb-2 text-muted mt-3"
                          >
                            {moment(game.start_date.toDate()).format(
                              "DD MMM YYYY"
                            )}
                          </CardSubtitle>
                          <div className="d-flex mt-3">
                            <p className="mt-1">Price:</p>
                            <p className="px-2 mt-1 text-green-1">
                              ${game.price}
                            </p>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                this.isItemInCart(game.id)
                                  ? this.props.removeGameFromCart(game.id)
                                  : this.props.addGameToCart(game.id);
                              }}
                              className="ms-auto text-white-1 px-4 bg-dark-4 btn-join"
                            >
                              {this.isItemInCart(game.id)
                                ? "Remove"
                                : "Join Now"}
                            </button>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                ))
            ) : (
              <div className="d-flex align-items-center justify-content-center my-5">
                No Game Found
              </div>
            )}
          </Row>
        </Container>
        <Footer />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    game: state.game,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchGames: () => dispatch(fetchGames()),
    addGameToCart: (id) => dispatch(addGameToCard(id)),
    removeGameFromCart: (id) => dispatch(removeGameFromCard(id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Games);
